module.exports = __webpack_public_path__ + "media/images/user1-128x128-f07d66e00150e23a0d8b2e10b7b0f86b.jpg";